
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Login';
import Categories from './Pages/Categories';
import BrandModel from './Pages/BrandModel';
import Brand from './Pages/Brand';
import FrameCategory from './Pages/FrameCategory';
import Frames from './Pages/Frames';
import PrivateRoutes from './Authorization/PrivateRoutes';
import Slider from './Pages/Slider';
import Plans from './Pages/Plans';
import PlansList from './Pages/PlansList';
import User from './Pages/User';
import Userdetail from './Pages/Userdetail';
import Videosection from './Pages/Videosection';
import AboutUs from './Pages/AboutUs';
import ContactUs from './Pages/ContactUs';
import Camplain from './Pages/Camplain';
import Privacypolicy from './Pages/Privacypolicy';
import Deletepolicy from './Pages/Deletepolicy';
import RecordingPage from './Pages/RecordingPage';

function App() {
  return (

    <>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path='/dash' element={<Dashboard />} />
            <Route path='/slider' element={<Slider />} />
            <Route path='/category' element={<Categories />} />
            <Route path='/brandmodel' element={<BrandModel />} />
            <Route path='/brand' element={<Brand />} />
            <Route path='/framecategory' element={<FrameCategory />} />
            <Route path='/frames' element={<Frames />} />
            <Route path='/planning' element={<Plans />} />
            <Route path='/planning/:id' element={<Plans />} />
            <Route path='/planslist' element={<PlansList />} />
            <Route path='/user' element={<User />} />
            <Route path='/videosection' element={<Videosection />} />

            <Route path='/user/detail' element={<Userdetail />} />
            <Route path='/aboutus' element={<AboutUs />} />
            <Route path='/contact' element={<ContactUs />} />
            <Route path='/complain' element={<Camplain />} />






          </Route>
          <Route path='/' element={<Login />} />
          <Route path='/privacy-policy' element={<Privacypolicy />} />
          <Route path='/delete-policy' element={<Deletepolicy />} />
          <Route path='/recording' element={<RecordingPage />} />


        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;


